export default __webpack_public_path__ + "static/media/in_progress.9307e32a.svg";